import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import PhoneInput from "./PhoneInput";
import OtpInput from "./OtpInput";
import HandleEmail from "./HandleEmail";
import HandleReset from "./HandleLinkReset";
import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";

const BASE_URL = import.meta.env.VITE_API_URL;

interface phoneProps {
  phone_number: string,
  country_code : string
}
const sendOtp = async(_payload: phoneProps) => {
  try {
    const res = await fetch(`${BASE_URL}/mobile/send-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_payload)
    });

    return await res.json()
  } catch (error) {
    console.error("Error:", error);
  }
}

const verifyOtp = async(OTP: string) => {
  try {
    const res = await fetch(`${BASE_URL}/mobile/verify-otp?otp_code=${OTP}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
    return await res.json()
  } catch (error) {
    console.error("Error:", error);
  }
}

const sendAlimtalk = async(_payload: phoneProps) => {
  try {
    const res = await fetch(`${BASE_URL}/user/find-my-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_payload)
    });
    
    return await res.json()
  } catch (error) {
    console.error("Erorr:", error);
  }
}
const HandleInput: React.FC = () => {
  const { pathname } = useLocation();
  const [isPage, setIsPage] = useState("phone");
  const loading = false
  const [isLoading, setIsLoading] = useState(false)
  const [phoneUser, setPhoneUser] = useState({
    phone_number: "",
    country_code : ""
  })

  const otpMutation = useMutation({
    mutationFn: (_payload: phoneProps)=> sendOtp(_payload),
    onSuccess: (res)=> {
      if(res.meta.code !== 200) {
        Swal.fire({
          icon: "warning",
          title: "ID가 잘못되었습니다",
          text: `등록된 휴대폰번호가 없습니다.`,
          confirmButtonColor: "bg-red-500",
          customClass: {
            confirmButton: "px-6 py-2 bg-red-500 text-white",
          },
        });
        return
      }
      setIsLoading(false)
      setIsPage("otp");
    },
    onError: (error)=> {
      console.error("Error:", error);
    }
  })

  const verifyOtpMutation = useMutation({
    mutationFn: (OTP : string) => verifyOtp(OTP),
    onSuccess: (res)=> {
      if(res.meta.code !== 200) {
        Swal.fire({
          icon: "warning",
          title: "유효하지 않은 OTP입니다.",
          text: `${res.meta.message}`,
          confirmButtonColor: "bg-red-500",
          customClass: {
            confirmButton: "px-6 py-2 bg-red-500 text-white",
          },
        });
        return
      }
      setIsLoading(false)
      setIsPage("findUsername")
    },
    onError: (error)=> {
      console.error("Error:", error); 
    }
  })

  const alimtalkMutation = useMutation({
    mutationFn: (_payload: phoneProps) => sendAlimtalk(_payload),
    onSuccess:(res)=> {
      if(res.meta.code !== 200) {
        Swal.fire({
          icon: "warning",
          title: "ID가 잘못되었습니다",
          text: `등록된 휴대폰번호가 없습니다.`,
          confirmButtonColor: "bg-red-500",
          customClass: {
            confirmButton: "px-6 py-2 bg-red-500 text-white",
          },
        });
        return
      }
      setIsLoading(false)
      setIsPage("linkReset")
    },
    onError:(error)=> {
      console.error("Error:", error); 
    }
  })


  const HandleSubmit = async (_payload: any) => {
    setIsLoading(true)
    if (isPage === "phone") {
      setPhoneUser(_payload)
      if (pathname == "/forgot-password") {
        alimtalkMutation.mutate(_payload)
      } else {
        otpMutation.mutate(_payload)
      }
    } else if (isPage === "otp") {
      verifyOtpMutation.mutate(_payload)
    }
    setTimeout(()=>{
      setIsLoading(false)
    },1000)
  };

  const handleBack = (page: string) => {
    setIsPage(page)
  }

  const handleResend = () => {
    alimtalkMutation.mutate(phoneUser)
  }

  return (
    <>
      <div className="content-center justify-center px-3 min-h-[50vh]">
        <div className="rounded p-6 w-full z-10 ">
          {loading ? (
            <div className="flex justify-center items-center">
              <ClipLoader color="#4A90E2" size={50} />
            </div>
          ) : isPage === "phone" ? (
            <PhoneInput onSubmit={HandleSubmit} isLoading={isLoading}/>
          ) : isPage === "otp" ? (
            <OtpInput onVerify={HandleSubmit} handleBack={handleBack} isLoading={isLoading}/>
          ) : isPage === "linkReset" ? (
            <HandleReset handleBack={handleBack} resend={handleResend} phoneUser={phoneUser}/>
          ) : (
            <HandleEmail phoneUser={phoneUser}/>
          )}
        </div>
      </div>
    </>
  );
};

export default HandleInput;
